module.exports = (__webpack_require__(77))(1);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/webpack/buildin/global.js from dll-reference vendor
// module id = 50
// module chunks = 0